export const colors = {
    error: '#C63527',
    lightError: '#F9EBE9',
    info: '#0072AD',
    success: '#3E8529',
    lightSuccess: '#f0faee',
    warning: '#caa416',
    deleteRedHover: '#ad1c0e',
    darkWarning: '#CAA416',
    white: '#FFFFFF',
    lightGrey: '#F6F6F6',
    mediumGrey: '#E0E0E0',
    darkGrey: '#656565',
    black: '#333333',
    silver: '#C0C0C0',
    mediumWarning: '#8A6C00'
};
export const tag = {
    scheduled: {
        icon: '#3C777C',
        background: '#EEF6F7'
    },
    processingCharged: {
        icon: '#333333',
        background: '#E9EAEB'
    },
    posted: {
        icon: '#3E8529',
        background: '#ECF3EA'
    },
    canceled: {
        icon: '#C63527',
        background: '#F9EBE9'
    },
    rejected: {
        icon: '#C99E00',
        background: '#FFF9E6'
    },
    defaultColors: {
        icon: '#333333',
        background: ' #E9EAEB'
    }
};
export const staticIcons = {
    statementsIconPrimary: '#34657F',
    statementsIconBackground: '#F0F3F5'
};
export const mockTheme = Object.assign(Object.assign(Object.assign({}, colors), staticIcons), { pieChart: {
        inProgress: '#34657f'
    }, body: {
        background: '#F6F6F6',
        text: '#333333'
    }, link: '#34657f', icon: '#34657f', 
    // The color used to alter the browser default focus color
    focus: '#34657f', 
    // For dropdown hover states, table row hover, and selected item background
    hoverBackground: '#E8F1FB', 
    // The colors used to set the default (html) body text color and body background color, not to be confused with the body typography element
    systemNavigation: {
        background: '#FFFFFF'
    }, modal: { background: '#FFFFFF', headerBackground: '#F6F6F6' }, accordion: {
        borderColor: '',
        headerBackgroundColor: '',
        activeHeaderBackgroundColor: ''
    }, button: {
        text: '#34657f',
        background: '#34657f',
        primary: {
            text: '#FFFFFF',
            hover: '#0072ad'
        },
        secondary: {
            text: '#34657f',
            hover: '#ebf0f2'
        }
    }, tooltip: {
        borderColor: '#9AB2BF',
        backgroundColor: '#ffffff',
        color: '#333333'
    }, binart: {
        background: '',
        disableBackground: ''
    }, field: {
        icon: '#34657f',
        focus: '#34657f',
        label: '#34657f'
    }, checkbox: {
        background: '#34657f',
        font: '#FFFFFF'
    }, chip: {
        hover: '',
        text: ''
    }, switch: {
        background: '#34657f'
    }, radio: {
        border: '',
        background: ''
    }, navigation: {
        activeTabText: '#34657f',
        activeTabBorder: '#34657f'
    }, datepicker: {
        navIcon: '#515151',
        shadow: 'rgba(0, 0, 0, 0.8)',
        disabled: '#e9e9e9',
        legend: {
            selectedDate: {
                fill: '#34657f',
                border: '#34657f',
                text: '#ffffff'
            },
            dueDate: {
                fill: '#ffffff',
                border: '#000000',
                text: '#000000'
            },
            pastDueDate: {
                fill: '#ffffff',
                border: '#AA0F00',
                text: '#656565'
            },
            lateFeeDate: {
                fill: '#757575',
                border: '#757575',
                text: '#ffffff'
            }
        }
    }, footer: {
        background: '#FFFFFF',
        text: '#333333',
        border: ''
    }, header: {
        background: '#F6F6F6',
        text: '',
        border: '' // just dsecurity: headerDivider
    }, progressStepBar: {
        fill: '',
        hover: '',
        label: ''
    }, progressBar: {
        complete: '#3e8529',
        error: '#c63527',
        inProgress: '#0072ad',
        background: '#e9eaeb'
    } });
const theme = {
    colors,
    tag,
    staticIcons
};
export default theme;
